import { SET_AVAILABLE_LICENSES, RESET_AVAILABLE_LICENSES } from './types';

/**
 * Sets the available licenses in the Redux store and localStorage
 * @param {Array} licenses - Array of license objects with catalog limit info
 * @returns {Object} Redux action
 */
export const setAvailableLicenses = (licenses) => {
    // Save licenses in localStorage as backup
    localStorage.setItem("availableLicenses", JSON.stringify(licenses));

    return {
        type: SET_AVAILABLE_LICENSES,
        payload: licenses
    };
};

/**
 * Resets the available licenses in the Redux store and localStorage
 * @returns {Object} Redux action
 */
export const resetAvailableLicenses = () => {
    // Remove from localStorage
    localStorage.removeItem("availableLicenses");
    
    return {
        type: RESET_AVAILABLE_LICENSES
    };
};
